import $ from 'jquery';
// Reason: more readable with brackets
// prettier-ignore
const main = () => {
    $(document).ready(() => {
        /* SWIPER */
        // Reason: completely working class
        // prettier-ignore
        class Swipe {
            constructor(element) {
                this.xDown = null;
                this.yDown = null;
                this.element = typeof(element) === 'string' ? document.querySelector(element) : element;

                this.element.addEventListener('touchstart', (evt) => {
                    this.xDown = evt.touches[0].clientX;
                    this.yDown = evt.touches[0].clientY;
                }, false);

            }

            onLeft(callback) {
                this.onLeft = callback;

                return this;
            }

            onRight(callback) {
                this.onRight = callback;

                return this;
            }

            onUp(callback) {
                this.onUp = callback;

                return this;
            }

            onDown(callback) {
                this.onDown = callback;

                return this;
            }

            handleTouchMove(evt) {
                if ( ! this.xDown || ! this.yDown ) {
                    return;
                }

                const xUp = evt.touches[0].clientX;
                const yUp = evt.touches[0].clientY;

                this.xDiff = this.xDown - xUp;
                this.yDiff = this.yDown - yUp;

                if ( Math.abs( this.xDiff ) > Math.abs( this.yDiff ) ) { // Most significant.
                    if ( this.xDiff > 0 ) {
                        this.onLeft();
                    } else {
                        this.onRight();
                    }
                } else if ( this.yDiff > 0 ) {
                    this.onUp();
                } else {
                    this.onDown();
                }

                // Reset values.
                this.xDown = null;
                this.yDown = null;
            }

            run() {
                this.element.addEventListener('touchmove', (evt) => {
                    this.handleTouchMove(evt).bind(this);
                }, false);
            }
        }


        /* HEADER */

        // Hide Header on on scroll down
        let navbarHeight = $('header').outerHeight();
        const header = $('header');
        $('main').css("padding-top", + navbarHeight);

        let previousPosition = window.scrollY;
        let after50hide = false;

        window.onscroll = () => {
            navbarHeight = $('header').outerHeight();
            const scrollPosition = window.scrollY;
            if (scrollPosition === 0) {
              after50hide = false;
            }



            if (scrollPosition <= navbarHeight && after50hide === false) {
              // If your scroll position is before header ends - do nothing
            } else if (previousPosition < scrollPosition && scrollPosition > navbarHeight) {
              // If you scroll down & you are after header ends - hide
              header.css("top", -navbarHeight);
            } else {
              // If you scroll up - hide
              after50hide = true;
              if (previousPosition - 20 > scrollPosition || scrollPosition < 500) { // If scrolled fast 20px or you are in header area
                header.css("top", "0");
              }
            }

            previousPosition = scrollPosition;
        };


        /* HAMBURGER */
        $('.ham').on('click', function() {
            $(this).toggleClass('active');
            $('.header_menu_div').toggleClass('active');
            $('body').toggleClass('overflow-hidden-mobile');
            $('main, footer').toggleClass('element-inactive');
        });

        /* SLIDER */
        $('.slide-list').on('click', '.slide-pin', function() {
            $('.slide-pin').removeClass('active');
            $('.slide-box').removeClass('active');
            $(this).addClass('active');
            $('.slide-box').eq($(this).attr('data-image_index') - 1).addClass('active');

        });

        /* eslint-disable */
        function slider_swipe(direction) {
            var img_index = '';
            if (direction === 'left') {

                img_index = $('.slide-box.active').prev('.slide-box').attr('data-image_index') - 1;
                if($('.slide-box').hasClass('corner-infinite')) {
                    if(!$('.slide-box.active').prev('.slide-box').length) {
                        img_index = $('.slide-box').last().attr('data-image_index') - 1;
                    }
                }
                else if($('.slide-box.active').prev('.slide-box').length) {
                    img_index = $('.slide-box.active').prev('.slide-box').attr('data-image_index') - 1;
                }
                else {
                    img_index = 'abc';
                }
                if(img_index  !== 'abc') {
                    $('.slide-box').removeClass('active');
                    $('.slide-pin').removeClass('active');
                    $('.slide-box').eq(img_index).addClass('active');
                    $('.slide-pin').eq(img_index).addClass('active');
                }

            }
            else {
                if($('.slide-box').hasClass('corner-infinite')) {
                    if(!$('.slide-box.active').next('.slide-box').length) {
                        img_index = $('.slide-box').first().attr('data-image_index') - 1;
                    }
                    else {
                        img_index = $('.slide-box.active').next().attr('data-image_index') - 1 ;
                    }

                }
                else if($('.slide-box.active').next('.slide-box').length) {
                    img_index = $('.slide-box.active').next('.slide-box').attr('data-image_index') - 1;
                }
                else {
                    img_index = 'abc';
                }
                if(img_index  !== 'abc') {
                    $('.slide-box').removeClass('active');
                    $('.slide-pin').removeClass('active');
                    $('.slide-box').eq(img_index).addClass('active');
                    $('.slide-pin').eq(img_index).addClass('active');
                }

            }
        }
        /* eslint-enable */
        if($('.slide-box').length){
            const swiper = new Swipe('.slide-box');
            swiper.onRight(() => {slider_swipe('left');});
            swiper.onLeft(() => {slider_swipe('right');});
            swiper.run();
        }

        $('.slide-box').on('click','.slide-corner', function() {
            if($(this).hasClass('corner-left')) {
                slider_swipe('left');
            }
            if($(this).hasClass('corner-right')) {
                slider_swipe('right');
            }
        });



        /* Tabs */
        $('.button.tab').on('click', function (){
            if(!$(`#${  $(this).attr('data-tab')}`).is(':visible')) {
                $('.custom_text').hide();
                $('.button.tab.active').removeClass('active');
                $(this).addClass('active');
                $(`#${$(this).attr('data-tab')}`).fadeIn();
            }
        });

    });
};
export default main;



// WEBPACK FOOTER //
// ./src/scripts/modules/main.js